// extracted by mini-css-extract-plugin
export var actions = "_13-0";
export var actionsContainer = "_13-6";
export var border = "_13-1";
export var childFullHeight = "_13-d";
export var collapse = "_13-2";
export var content = "_13-8";
export var contentChild = "_13-c";
export var fullscreen = "_13-a";
export var hasLeftRadius = "_13-h";
export var headerContainer = "_13-3";
export var headerRow = "_13-5";
export var hidePadding = "_13-9";
export var navCollapsedGap = "_13-i";
export var noScrollX = "_13-j";
export var noScrollY = "_13-k";
export var optOutTopPadding = "_13-b";
export var pageMain = "_13-g";
export var pageOuter = "_13-e";
export var pagePadding = "_13-7";
export var profile = "_13-l";
export var profileContainer = "_13-m";
export var profileImage = "_13-n";
export var profileMain = "_13-o";
export var profileSubtitle = "_13-q";
export var profileTitle = "_13-p";
export var showLeftPadding = "_13-f";
export var tabsWrapper = "_13-4";
export var title = "_13-r";